/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AccountProtectionState {
  loading: boolean;
  insurancedetailSuccess: any | null;
  insurancedetailError: any | null;
  enrollAccountProtectionServiceLoading: boolean;
  enrollAccountProtectionServiceDetails: any | null;
  enrollAccountProtectionServiceError: any | null;
}

const initialState: AccountProtectionState = {
  loading: false,
  insurancedetailSuccess: null,
  insurancedetailError: null,
  enrollAccountProtectionServiceLoading: false,
  enrollAccountProtectionServiceDetails: null,
  enrollAccountProtectionServiceError: null,
};

const accountProtectionSlice = createSlice({
  name: 'accountProtection',
  initialState,
  reducers: {
    accountProtectionRequest(
      state,
      _action: PayloadAction<{ accountId: string; customerId: string }>
    ) {
      state.loading = true;
      state.insurancedetailSuccess = null;
      state.insurancedetailError = null;
      state.enrollAccountProtectionServiceDetails = null;
      state.enrollAccountProtectionServiceError = null;
    },
    accountProtectionSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.insurancedetailSuccess = action.payload; // full success payload (message, statuscode, etc.)
      state.insurancedetailError = null;
    },
    accountProtectionFailed(state, action: PayloadAction<any>) {
      state.loading = false;
      state.insurancedetailSuccess = null;
      state.insurancedetailError = action.payload; // normalized error payload
    },
    enrollAccountProtectionServiceRequest(state, action: PayloadAction<any>) {
      state.enrollAccountProtectionServiceLoading = true;
      state.enrollAccountProtectionServiceDetails = null;
      state.enrollAccountProtectionServiceError = null;
    },
    enrollAccountProtectionServiceSuccess(state, action: PayloadAction<any>) {
      state.enrollAccountProtectionServiceLoading = false;
      state.enrollAccountProtectionServiceDetails = action.payload;
      state.enrollAccountProtectionServiceError = null;
    },
    enrollAccountProtectionServiceFailed(state, action: PayloadAction<any>) {
      state.enrollAccountProtectionServiceLoading = false;
      state.enrollAccountProtectionServiceError = action.payload;
    },
    resetAccountProtectionState() {
      return initialState;
    },
  },
});

export const {
  accountProtectionRequest,
  accountProtectionSuccess,
  accountProtectionFailed,
  resetAccountProtectionState,
  enrollAccountProtectionServiceRequest,
  enrollAccountProtectionServiceSuccess,
  enrollAccountProtectionServiceFailed,
} = accountProtectionSlice.actions;

export default accountProtectionSlice.reducer;
